"use client";

// src/logo.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var Logo = (props) => {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      version: "1.0",
      xmlns: "http://www.w3.org/2000/svg",
      width: 160,
      height: 42,
      viewBox: "0 0 900 240",
      preserveAspectRatio: "xMidYMid meet",
      ...props,
      children: [
        /* @__PURE__ */ jsxs("defs", { children: [
          /* @__PURE__ */ jsxs("linearGradient", { id: "orbGradient", x1: "0%", y1: "0%", x2: "100%", y2: "100%", children: [
            /* @__PURE__ */ jsx("stop", { offset: "0%", style: { stopColor: "#4F46E5" } }),
            " ",
            /* @__PURE__ */ jsx("stop", { offset: "100%", style: { stopColor: "#818CF8" } }),
            " "
          ] }),
          /* @__PURE__ */ jsxs("filter", { id: "glow", children: [
            /* @__PURE__ */ jsx("feGaussianBlur", { stdDeviation: "2", result: "coloredBlur" }),
            /* @__PURE__ */ jsxs("feMerge", { children: [
              /* @__PURE__ */ jsx("feMergeNode", { in: "coloredBlur" }),
              /* @__PURE__ */ jsx("feMergeNode", { in: "SourceGraphic" })
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: "120",
            cy: "120",
            r: "80",
            fill: "none",
            stroke: "url(#orbGradient)",
            strokeWidth: "10",
            strokeDasharray: "25 12",
            className: "animate-spin-slow",
            style: { filter: "url(#glow)" }
          }
        ),
        /* @__PURE__ */ jsx(
          "circle",
          {
            cx: "120",
            cy: "120",
            r: "35",
            fill: "url(#orbGradient)",
            opacity: "0.9",
            style: { filter: "url(#glow)" }
          }
        ),
        /* @__PURE__ */ jsx("g", { transform: "translate(240, 150)", children: /* @__PURE__ */ jsxs(
          "text",
          {
            fill: "currentColor",
            fontSize: "95",
            fontFamily: "var(--font-geist-sans), system-ui, -apple-system, sans-serif",
            fontWeight: "600",
            letterSpacing: "0.5",
            style: {
              fontFeatureSettings: "'ss01' on, 'ss02' on",
              fontVariationSettings: "'wght' 600"
            },
            children: [
              /* @__PURE__ */ jsx("tspan", { className: "text-slate-600 dark:text-slate-100", letterSpacing: "0.2", children: "Proxy" }),
              /* @__PURE__ */ jsx("tspan", { className: "text-indigo-600 dark:text-indigo-500", letterSpacing: "0.8", dx: "8", children: "Orb" })
            ]
          }
        ) })
      ]
    }
  );
};

export {
  Logo
};
